import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  DialogProps,
  Typography
} from '@mui/material';

export type AppDialogProps = {
  open: boolean;
  onClose: () => void;
  title: React.ReactNode;
  description?: React.ReactNode;
  children?: React.ReactNode;
  actions?: React.ReactNode;
  maxWidth?: DialogProps['maxWidth'];
  fullWidth?: boolean;
};

export const AppDialog: React.FC<AppDialogProps> = ({
  open,
  onClose,
  title,
  description,
  children,
  actions,
  maxWidth = 'xs',
  fullWidth = true
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      PaperProps={{
        sx: {
          borderRadius: 3,
          border: (theme) => `1px solid ${theme.designSystem.surface.panelBorder}`,
          background: (theme) => theme.designSystem.surface.panelBackground,
          boxShadow: (theme) => theme.designSystem.surface.panelShadow
        }
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Typography variant="h6" fontWeight={700}>
          {title}
        </Typography>
      </DialogTitle>

      {(description || children) && (
        <DialogContent sx={{ pt: 0 }}>
          {description ? (
            <DialogContentText color="text.secondary">
              {description}
            </DialogContentText>
          ) : null}
          {children}
        </DialogContent>
      )}

      {actions ? <DialogActions sx={{ px: 3, pb: 3, pt: 2, gap: 1 }}>{actions}</DialogActions> : null}
    </Dialog>
  );
};

